import { useState, useEffect } from 'react';
import axios from 'axios';
import Navbar from '../components/Navbar';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Team() {
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/pages/team`)
      .then(res => setContent(res.data.content || ''))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen bg-slate-50" data-testid="team-page">
      <Navbar />
      <div className="pt-24 pb-12 px-6">
        <div className="max-w-6xl mx-auto">
          <h1 className="text-5xl font-serif font-bold tracking-tight text-slate-900 mb-4 text-center">Our Team</h1>
          <p className="text-xl text-slate-600 mb-12 text-center">Meet the experts behind The Case Verse</p>
          {loading ? (
            <div className="flex justify-center py-12"><div className="animate-spin rounded-full h-8 w-8 border-b-2 border-slate-900"></div></div>
          ) : content ? (
            <div className="prose prose-slate max-w-none bg-white p-8 rounded border border-slate-200" data-testid="team-content" dangerouslySetInnerHTML={{ __html: content }} />
          ) : (
            <p className="text-slate-500 text-center">Content coming soon.</p>
          )}
        </div>
      </div>
    </div>
  );
}
